import {withStylesProvider} from '../../utils/withStylesProvider';

// Import components
import {RadioButtonGroup as InternalRadioButtonGroup} from './RadioButtonGroup';
import RadioButtonDefault from './RadioButton';
import {StylesProvider} from './context';
import {radioButtonGroupTheme} from './theme/theme';

// Export types
export type {RadioButtonProps} from './RadioButton';
export type {RadioButtonGroupProps} from './RadioButtonGroup';

// Create the enhanced RadioButtonGroup component
const EnhancedRadioButtonGroup = withStylesProvider(
  InternalRadioButtonGroup,
  StylesProvider,
  radioButtonGroupTheme,
) as typeof InternalRadioButtonGroup;

// Export components
export {EnhancedRadioButtonGroup as RadioButtonGroup};
export {RadioButtonDefault as RadioButton};
